import { render, staticRenderFns } from "./DialogFull.vue?vue&type=template&id=0e10cf23&"
import script from "./DialogFull.vue?vue&type=script&lang=js&"
export * from "./DialogFull.vue?vue&type=script&lang=js&"
import style0 from "./DialogFull.vue?vue&type=style&index=0&id=0e10cf23&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports